// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"65c350fe","123":"ce7ea87e","144":"7ce4f972","341":"b47fb948","344":"d2720fc8","372":"0650befe","453":"fe30c2ce","578":"fbe98c0a","650":"b3a46606","799":"aca8cca7"}[chunkId] + ".chunk.js";
};